import { computed } from 'vue';
import { useRoute } from 'vue-router';

export function useGowa() {
  const route = useRoute();
  const enabled = computed(
    () =>
      window.chatwootConfig?.gowaEnabled &&
      String(route.params.accountId) === window.chatwootConfig.gowaAccountId
  );
  return { enabled };
}
